import { FC, Suspense } from 'react';
import { useFlag } from '@unleash/proxy-client-react';
import { LTS_SHUTOFF_PP_435_WEEKLY_GOAL_FLAG, useWeeklyGoal } from '../../contexts/WeeklyGoalContext';
import WeeklyGoalContent from './WeeklyGoalContent';
import { ThreeDotLoader } from '../Fallback/ThreeDotsLoader';

export interface GoalValue {
  code: string;
  name: string;
  skillType: string;
}
export interface GoalCenter {
  spanClasses: string | null;
  spanValue: React.ReactNode;
  centerClasses: string;
}

const WeeklyGoalWrapper: FC = () => {
  const ctx = useWeeklyGoal();
  const isEnabled = !useFlag(LTS_SHUTOFF_PP_435_WEEKLY_GOAL_FLAG);
  if (!isEnabled || !ctx) return null;
  const { queryRef, overrideData } = ctx;
  if (!queryRef) return null;

  return (
    <Suspense fallback={<ThreeDotLoader dark />}>
      <WeeklyGoalContent queryRef={queryRef} overrideData={overrideData} />
    </Suspense>
  );
};

export default WeeklyGoalWrapper;
